var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaloon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 96,
    viewBox: "0 0 52 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8021 73.6412L20.1055 83.7413",
    stroke: "#404042",
    strokeWidth: 1.02393,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0882 83.7418L31.1646 83.5601L31.8727 93.781L36.3595 91.5042L36.0882 83.7418ZM29.9979 83.6005L29.8207 83.621L20.957 84.6234L21.6262 93.7856L30.7039 93.8214",
    fill: "#EF4C2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3972 82.2177L30.474 70.4701L29.083 70.8679L30.1622 81.6663",
    stroke: "#404042",
    strokeWidth: 1.02393,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2485 71.4889L22.0808 72.197L22.2841 67.9548C22.2841 67.9548 11.8528 51.0246 8.23213 47.9748C8.23213 47.9748 -8.40064 24.5554 10.0619 9.79334C10.0619 9.79334 23.9859 -4.10502 36.314 6.75892C36.314 6.75892 61.1741 24.2436 40.0084 52.1596C40.0084 52.1596 30.6353 65.545 30.6599 66.25C30.6844 66.9555 32.2485 71.4889 32.2485 71.4889Z",
    fill: "#33D9B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.811 2.42664C30.811 2.42664 41.3114 21.503 42.0625 31.234C42.813 40.9644 35.304 60.6695 35.304 60.6695M14.0728 4.85592C14.0728 4.85592 10.3518 22.5188 10.4777 31.3123C10.6037 40.1064 14.8264 57.4917 14.8264 57.4917M22.9303 0.857971C22.9303 0.857971 24.4119 20.2497 24.7857 29.9935C25.1594 39.7372 25.1681 59.1797 25.1681 59.1797",
    stroke: "#404042",
    strokeWidth: 1.02393,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaloon);
export default __webpack_public_path__ + "static/media/baloon.a1d4c12826f3a3523bdbd8919326ff83.svg";
export { ForwardRef as ReactComponent };